export default {
	GET_DETAILS: "get_details",
	GET_USER_BY_EMAIL: "get_user_by_email",
	GET_WORKFORCE_BY_EMAIL: "get_workforce_details_by_email",
	GET_PATIENT_BY_EMAIL: "get_patient_details_by_email",
	GET_ALL_PATIENTS: "get_all_patient",
	SEARCH_PATIENT: "search_patient",
	GET_ALL_WORKFORCE: "get_all_workforce",
	GET_TEAM_MEMBERS: "get_team_members",
	SEARCH_WORKFORCE: "search_workforce",
	GET_WORKFORCE_BY_ROLE: "get_workforce_by_role",
	GET_ALL_VISIT: "get_all_visit",
	ADD_SCHEDULE: "add_schedule",
	REJECT_VISIT: "reject_visit",
	UPDATE_VISIT: "update_visit",
	ACCEPT_VISIT: "accept_visit",
	GET_VISIT_DETAILS: "get_visit_details",
	ADD_FORMDATA: "add_formdata",
	ADD_PUBLIC_FORMDATA: "add_public_formdata",
	UPDATE_FORMDATA: "update_formdata",
	GET_FORMDATA: "get_formdata",
	GET_CONFIGURATION: "get_configuration",
	GET_PUBLIC_CONFIGURATION: "get_public_configuration",
	ASSIGN_VISIT: "assign_visit",
	GET_PATIENT_DETAILS_BY_USER_IDENTIFIER: "get_patient_details_by_user_identifier",
	GET_WORKFORCE_DETAILS_BY_USER_IDENTIFIER: "get_workforce_details_by_user_identifier",
	ADD_WORKFORCE: "add_workforce",
	SEND_INVITE_TO_WORKFORCE: "send_invite_to_workforce",
	ADD_CONFIGURATION: "add_configuration",
	ADD_WORKFORCE_SERVICE: "add_workforce_service",
	DELETE_WORKFORCE_SERVICE: "delete_workforce_service",
	GET_WORKFORCE_SERVICE: "get_workforce_service",
	GET_ORGANIZATION_SERVICES: "get_organization_services",
	UPDATE_WORKFORCE: "update_workforce",
	UPDATE_PATIENT: "update_patient",
	GET_ALL_FORMS: "get_all_forms",
	GET_VISIT_FORMS: "get_visit_forms",
	UPDATE_CONFIGURATION: "update_configuration",
	SEND_NOTIFICATION: "send_notification",
	GET_NOTIFICATION: "get_notification",
	GET_UNREAD_NOTIFICATION_COUNT: "get_unread_notification_count",
	GET_COORDINATOR_AND_VOLUNTEER_FORMS: "get_coordinator_and_volunteer_forms",
	GET_ALL_GROUPS: "get_all_groups",
	SEND_GROUP_NOTIFICATION: "send_group_notification",
	ADD_CARE_PLAN: "add_care_plan",
	UPDATE_OPPORTUNITY: "update_opportunity",
	GET_ALL_WORKFORCE_ENTITY_RECOMMENDER: "get_all_workforce_entity_recommender",
	GET_PRIORITY_DATA: "get_priority_data",
	ACCEPT_OPPORTUNITY: "accept_opportunity",
	REJECT_OPPORTUNITY: "reject_opportunity",
	ADD_DELIVERY: "add_delivery",
	UPDATE_DELIVERY: "update_delivery",
	GET_DELIVERIES_FOR_APPROVAL: "get_deliveries_for_approval",
	CREATE_TAG: "create_tag",
	GET_ALL_TAGS: "get_all_available_tags",
	UPDATE_TAG: "update_tag",
	DELETE_TAG: "delete_tag",
	ASSIGN_TAG_TO_ENTITY: "assign_tag_to_entity",
	GET_DELIVERIES: "get_deliveries",
	GET_OPPORTUNITIES: "get_opportunities",
	GET_DELIVERY_DETAILS: "get_delivery_details",
	GET_OPPORTUNITY_DETAILS: "get_opportunity_details",
	GET_TAGS_ASSIGNED_TO_ENTITY: "get_tags_assigned_to_entity",
	GET_DELIVERY_LIFECYCLE: "get_delivery_lifecycle",
	UNASSIGN_TAG_FROM_ENTITY: "unassign_tag_from_entity",
	UPDATE_ASSIGN_ENTITY_TAG: "update_entity_tag_relationship",
	GET_DELIVERIES_WITHOUT_APPROVAL: "get_deliveries_without_approval",
	GET_GROUP_BY_NAMESPACE: "get_group_by_namespace",
	GET_GROUP_MEMBERS_DETAILS: "get_group_members_details",
	DELETE_GROUP_MEMBERSHIP: "delete_group_membership",
	ADD_GROUP_MEMBERSHIP: "add_group_membership",
	ADD_GROUP_WITH_MEMBERSHIP: "add_group_with_membership",
	GET_OPPORTUNTITES_AND_DELIVERIES: "get_opportunities_and_deliveries",
	ROUTE: "route",
	ANALYZE_DATA: "analyze_data",
	GET_TREND_CHART_DATA: "get_trend_chart_data",
	GET_BILLING_DATA: "get_billing_data",
	GET_OCCASION_DATA: "get_occasion_data",
	SIGNUP: "signup",
	GET_WORKFORCE_BY_INVITATION_CODE: "get_workforce_by_invitation_code",
	GET_DECLINED_OPPORTUNITIES: "get_rejected_opportunities",
	ACCEPT_INVITATION: "accept_invitation",
	ADD_TEAM_MEMBER: "add_team_member",
	ADD_PATIENT:"add_patient",
	MIGRATE_PDV_NEW_PATIENTS:"migrate_pdv_new_patients",
	SEND_EVENT:"send_event",
	GET_REPORTING_LOGS:"get_reporting_logs",
	GET_PATIENT_REPORTING_LOGS:"get_patient_reporting_logs",
	EDIT_TABLE_DATA:"edit_table_data",
	GET_REPORT_NAMES:"get_report_names",
	GET_REPORT_DATA:"get_report_data",
	UPDATE_REPORT_DATA:"update_report_data",
	SAVE_REPORT_DATA:"save_report_data",
	DELETE_REPORT_DATA:"delete_report_data",
	GET_PATIENT_VOLUNTEER_REQUEST: "get_patient_volunteer_request",
	GET_PATIENT_DETAILS_MAP_BY_USER_IDENTIFIER: "get_patient_details_map_by_user_identifier",
	GET_WORKFORCE_DETAILS_MAP_BY_USER_IDENTIFIER: "get_workforce_details_map_by_user_identifier",
};